import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@/lib/api/config"; // Import API_BASE_URL from central config

/**
 * Returns property type list and options for select UIs.
 * Caches using react-query for reuse.
 */
export function usePropertyTypes() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["propertyTypes"],
    queryFn: async () => {
      const response = await axios.get(`${API_BASE_URL}/api/property-types`);
      console.log("[usePropertyTypes] API Response Data:", response.data);
      if (response.data && response.data.status === "success") {
        const propertyTypes =
          response.data.data?.propertyTypes ||
          response.data.data ||
          response.data.propertyTypes ||
          [];
        console.log(
          "[usePropertyTypes] Extracted Property Types:",
          propertyTypes
        );
        // Select options for UIs
        const propertyTypeOptions = propertyTypes.map((type: any) => ({
          value: String(type.id), // Use type.id as string for select value
          label: type.display_name || type.name,
        }));

        return {
          propertyTypes,
          propertyTypeOptions,
        };
      }
      return { propertyTypes: [], propertyTypeOptions: [] };
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  console.log("[usePropertyTypes] Hook return values:", {
    isLoading,
    dataExists: !!data,
    propertyTypesCount: data?.propertyTypes?.length || 0,
  });

  return {
    data: data?.propertyTypes || [],
    propertyTypes: data?.propertyTypes || [],
    propertyTypeOptions: data?.propertyTypeOptions || [],
    isLoading,
    error,
  };
}
